import * as React from 'react';
import { Button, Breadcrumb, Tabs, Row, Col } from 'antd';
import autobind from 'autobind-decorator';
import { Prompt } from 'react-router';
const TabPane = Tabs.TabPane;

import { DocumentGenerationController } from 'src/app/general/document-generation/document-generation.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { SupplierGeneralPartController } from './parts/suppliergeneral-part.controller';
import { SupplierContactPart } from './parts/suppliercontact-part';
import { ContextService } from 'src/core/services/context.service';
import { OfficeFormController } from '../../office/office-form.controller';
import { TransportCompanyOfficeListController } from '../../office/office-list.controller';
import { TransportCompanyOfficeListDataService } from '../../office/office.data';
import { ExtendedSchemaView } from 'src/core/ui/extended-schema.view';
import { ZuluIcon } from 'src/app/shared/icon';

interface SupplierFormViewProps extends ComponentViewProps<SupplierItem> {
	title: string,
	save: () => void,
	cancel: () => void;
	model: SupplierItem;
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	contextService: ContextService;
	officeDataService: TransportCompanyOfficeListDataService;
	breadcrumb?: any[];
	goToCard: (text: any, key: string, model: any, parentModel: Model) => void;
	isNew: boolean;
	schema: JsonSchema;
	onLogoChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;

}

export class SupplierFormView extends React.Component<SupplierFormViewProps, {}> {
	constructor(props: Readonly<SupplierFormViewProps>) {
		super(props);
	}

	private get hasExtendedProperties(): boolean {
		return this.props.schema.allOf != null && this.props.schema.allOf.length > 0 && Object.getOwnPropertyNames(this.props.schema.allOf[0].properties).length > 0;
	}

	@autobind
	private renderBreadcrumbItem(route: any, params: any, routes: Array<any>, paths: Array<string>) {
		return <Button style={{ height: '100%' }} key={route.breadcrumbName} onClick={() => route.onClick(route.breadcrumbName)}>
			{route.text}
			
		</Button>;
	}

	render() {
		if (this.props.model == null) {
			return null;
		}
		
		const latest = this.props.breadcrumb == null || this.props.breadcrumb.length == 1 ? null : this.props.breadcrumb[this.props.breadcrumb.length - 1];
		const breadcrum = this.props.breadcrumb == null || this.props.breadcrumb.length == 0 ? null
			: <div className='card header'>
				<Breadcrumb className='m-1' separator={<ZuluIcon type='right' />} itemRender={this.renderBreadcrumbItem} routes={this.props.breadcrumb.slice()} />
			</div>;
		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 3, span: 18 }}>
						{
							this.props.save &&
							<Row>
								<Col xs={24}>
									<HeaderView
										title={this.props.title}
										mode={this.props.mode}
										onModeChanged={this.props.onModeChanged}
										save={this.props.save}
										cancel={this.props.cancel}
										contextService={this.props.contextService}
									/>
								</Col>
							</Row>
						}
						{breadcrum}
						{latest == null && this.props.model && <Row>
							<Col xs={24}>
								<div className="card card-borderless">
									<Tabs defaultActiveKey="General information">
										<TabPane tab={<span>General information</span>} key="General information">
											{latest == null &&
												<Row gutter={16}>
													<Col span={24}>
														<Row gutter={16}>
															<Col span={8}>
																<SupplierGeneralPartController
																	mode={this.props.mode}
																	onModeChanged={this.props.onModeChanged}
																model={latest == null ? this.props.model : null}
																onLogoChange={this.props.onLogoChange}
																	setBusy={this.props.setBusy} />
															</Col>
															<Col span={16}>
																<SupplierContactPart
																	mode={this.props.mode}
																	parentModel={latest == null ? this.props.model : null}
																	model={latest == null ? this.props.model.dynamicProperties["contacts"] : null}
																	setBusy={this.props.setBusy}
																	contextService={this.props.contextService}
																/>
																{this.props.model.type == 1 &&
																	<TransportCompanyOfficeListController
																		model={latest == null ? this.props.model : null}
																		mode={this.props.mode}
																		onModeChanged={this.props.onModeChanged}
																		setBusy={this.props.setBusy}
																		contextService={this.props.contextService}
																		goToCard={this.props.goToCard}
																		dataService={this.props.officeDataService}
																	/>}
															</Col>
														</Row>
													</Col>
												</Row>
											}
										</TabPane>
										{this.hasExtendedProperties &&
											<TabPane tab={<span>Other Properties</span>} key="Other Properties">
												<ExtendedSchemaView
													mode={this.props.mode}
													columns={2}
													model={this.props.model.dynamicProperties}
													schema={this.props.schema}
													setBusy={this.props.setBusy}
													title="Other Information"
												/>
											</TabPane>
										}
										{!this.props.isNew &&
											<TabPane tab={<span>Documents</span>} key="documents">
												<Row>
													<Col span={24}>
														<DocumentGenerationController
															contextService={this.props.contextService}
															containerId={this.props.model.documentsLibraryId}
															setBusy={this.props.setBusy}
															usage="Suppliers"
															targetId={this.props.model.id}
														/>
													</Col>
												</Row>
											</TabPane>}
									</Tabs>
								</div>
							</Col>
						</Row>
						}
						{latest != null && latest.key == 'office' &&
							<OfficeFormController
								mode={this.props.mode}
								dataService={this.props.officeDataService}
								onModeChanged={this.props.onModeChanged}
								model={latest != null && latest.key == 'office' ? latest.item as TransportCompanyOfficeItem : null}
								setBusy={this.props.setBusy}
								contextService={this.props.contextService}
								supplier={this.props.model}
							/>
						}
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/suppliers/form/supplier-form.view.tsx